import { render, staticRenderFns } from "./SuitList.vue?vue&type=template&id=894ec7d6&scoped=true&"
import script from "./SuitList.vue?vue&type=script&lang=js&"
export * from "./SuitList.vue?vue&type=script&lang=js&"
import style0 from "./SuitList.vue?vue&type=style&index=0&id=894ec7d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ec7d6",
  null
  
)

export default component.exports